import app from 'flarum/forum/app';
import { livesBars, headline } from '../../common/retire';

/**
 * "Where to retire" on Voucha: the same retirement income in each place, side by side. No ranking: what it lives
 * like, what happens to each pension, health, safety, whether you may live there, family. Every source listed.
 */
const PENSION = {
  'uk-state': 'UK State Pension',
  cpp: 'CPP',
  oas: 'OAS',
  gis: 'GIS',
  'us-ss': 'US Social Security',
  workplace: 'Workplace or personal pension',
  'nigeria-rsa': 'Nigerian pension (RSA)'
};
const ICON = {
  ok: '✓',
  warn: '!',
  stop: '✕'
};
const full = (amount, currency) => {
  if (currency === 'NGN') {
    const a = Math.abs(amount);
    return '₦' + (a >= 1e6 ? (Math.round(a / 1e5) / 10).toLocaleString() + ' million' : (Math.round(a / 1000) * 1000).toLocaleString());
  }
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    }).format(amount);
  } catch (e) {
    return currency + ' ' + Math.round(amount).toLocaleString();
  }
};
export function retireResult(s) {
  const cur = s.home.currency;
  const money = v => full(v, cur);
  const ng = s.places.find(p => p.code === 'NG');
  return m("div", {
    className: "VRetire"
  }, m("section", {
    className: "VAssessResult-section"
  }, m("h2", null, headline(s, money)), m("div", {
    className: "VRetire-pic"
  }, m.trust(livesBars({
    places: s.places,
    currency: cur
  }))), m("p", {
    className: "VRetire-note"
  }, "What the same income buys in each place, priced as if you were spending it ", s.home.atHome ? 'in Nigeria' : 'where you live now', ". Averages for each country: World Bank price levels, 2024", ng ? ', with Nigeria kept up to date' : '', ".")), m("section", {
    className: "VAssessResult-section"
  }, m("h2", null, "Place by place"), m("div", {
    className: "VRetire-places"
  }, s.places.map(p => m("article", {
    className: 'VRetire-place' + (p.home ? ' is-home' : '')
  }, m("header", null, m("h3", null, p.name), m("span", {
    className: "VRetire-lives"
  }, "Lives like ", money(p.livesLike))), p.pensions.length ? m("ul", {
    className: "VRetire-lines"
  }, p.pensions.map(l => m("li", {
    className: 'is-' + l.status
  }, m("i", {
    "aria-hidden": "true"
  }, ICON[l.status]), m("span", null, m("strong", null, PENSION[l.key], ":"), " ", l.text)))) : null, m("dl", {
    className: "VRetire-facts"
  }, p.health ? [m("dt", null, "Health"), m("dd", null, p.health.share !== null ? Math.round(p.health.share) + '% of health spending paid out of pocket. ' : '', p.health.text)] : null, p.safety ? [m("dt", null, "Safety"), m("dd", null, p.safety[0], " homicides per 100,000 people (", p.safety[1], ")")] : null, m("dt", null, "Living there"), m("dd", {
    className: 'is-' + p.live.status
  }, p.live.text), p.family ? [m("dt", null, "Family"), m("dd", null, p.family)] : null), p.comfort ? m("p", {
    className: "VRetire-note"
  }, "Comfort costs: retirees from abroad often pay more than the average here for private healthcare, power (a generator or solar), imported medicine and security.") : null)))), m("details", {
    className: "VAssessResult-section VAssessResult-answersBox"
  }, m("summary", null, "How this was worked out"), m("ul", {
    className: "VStanding-assumptions"
  }, s.assumptions.map(a => m("li", null, a)))));
}

/** Tags to join: retirement, life abroad, and Nigeria's or the home country's tag if they exist */
export function retireTags(s) {
  const country = {
    CA: 'canada',
    GB: 'uk',
    US: 'usa'
  }[s.home.code];
  return ['retirement', 'diaspora', country].filter(Boolean).map(slug => app.store.getBy('tags', 'slug', slug)).filter(Boolean);
}
flarum.reg.add('voucha-assessments', 'forum/components/RetireResult', { retireResult: retireResult,retireTags: retireTags, });